export default __webpack_public_path__ + "static/media/bg3.5800c8d0.JPG";